import React, { FC } from 'react';
import './index.scss';

interface IProps {
    title: string;
}

const Panel: FC<IProps> = props => {
    const { title } = props;

    return (
        <div className="panel">
            <h3>{title}</h3>
            {props.children}
        </div>
    );
};

Panel.defaultProps = {
    title: '',
};

export default Panel;
